import { Http } from '@gamiphy/http';
import { Circle } from '@gamiphy/bl/connections';

export type CirclesResponse = {
  count: number,
  connections: Circle[]
}

export class CircleApi {
  public static async getConnections(): Promise<Circle[]> {
    const response = await Http.get<CirclesResponse>({
      url: '/v2/connections',
    });
    return response.data.connections;
  }
}
